import AppLayout from '../../../components/AppLayout';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import useClaimNewFunctions from './useClaimNewFunctions';
import ClaimSubmitted from './ClaimSubmitted';
import Header from './Header';
import FooterNav from './FooterNav';

// ═══════════════════════════════════════════════════════════
// FNOL FORM (4-step wizard — matches reference exactly)
// ═══════════════════════════════════════════════════════════
const ClaimNew = () => {
  const {
    S,
    history,
    step,
    setStep,
    submitted,
    setSubmitted,
    submitting,
    createdId,
    createdClaimNumber,
    workflowMsg,
    pendingFiles,
    setPendingFiles,
    formData,
    setFormData,
    steps,
    handleChange,
    handleCreate,
    inputStyle,
    labelStyle,
  } = useClaimNewFunctions();

  if (submitted) {
    return (
      <ClaimSubmitted
        workflowMsg={workflowMsg}
        createdClaimNumber={createdClaimNumber}
        history={history}
        createdId={createdId}
        setStep={setStep}
        setSubmitted={setSubmitted}
        setFormData={setFormData}
        S={S}
      />
    );
  }

  return (
    <AppLayout>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        {/* Header */}
        <Header history={history} step={step} steps={steps} S={S} />

        {/* Form content */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '32px', maxWidth: 720 }}>
          {step === 1 && <Step1 formData={formData} onChange={handleChange} S={S} inputStyle={inputStyle} labelStyle={labelStyle} />}
          {step === 2 && <Step2 formData={formData} onChange={handleChange} S={S} inputStyle={inputStyle} labelStyle={labelStyle} />}
          {step === 3 && <Step3 pendingFiles={pendingFiles} setPendingFiles={setPendingFiles} S={S} />}
          {step === 4 && <Step4 formData={formData} S={S} inputStyle={inputStyle} labelStyle={labelStyle} />}
        </div>

        {/* Footer navigation */}
        <FooterNav step={step} setStep={setStep} history={history} handleCreate={handleCreate} submitting={submitting} S={S} />
      </div>
    </AppLayout>
  );
};

export default ClaimNew;
